import React from 'react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  totalRecipients: number;
  totalMessages: number;
  totalCredits: number;
  deliveryDate: string;
  deliveryTime: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  totalRecipients,
  totalMessages,
  totalCredits,
  deliveryDate,
  deliveryTime,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <h2 className="text-xl font-bold text-gray-900">Message Sent Successfully</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Total Recipients</span>
            <span className="font-medium">{totalRecipients}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Total Messages</span>
            <span className="font-medium">{totalMessages}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Total Credits</span>
            <span className="font-medium">{totalCredits.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Delivery Date</span>
            <span className="font-medium">{deliveryDate}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Delivery Time</span>
            <span className="font-medium">{deliveryTime}</span>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#FF5722] text-white rounded hover:bg-[#F4511E] transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 